import RangePicker from './range-picker';

export default RangePicker;
